module.exports = __webpack_public_path__ + "static/finish-89b070f32c4e0549cd8633cfc1b750bb.jpg";